import React, { useState } from "react";
import Link from "next/link";
import { Grid } from "@mui/material";
import dynamic from "next/dynamic";
const ModalVideo = dynamic(() => import("react-modal-video"), { ssr: false });
import PlayButtonWithRipple from "@modules/study/common/play_btn_with_ripple";
import styles from "./intro.module.scss";
import Image from "next/legacy/image";
import { getAssets } from "@unisearch/helpers";

export const ElearningHomeIntro = () => {
  const [isOpen, setOpen] = useState(false);
  return (
    <section className={styles.section_intro}>
      <div className="container">
        <Grid container spacing={{ xs: 3, sm: 3, md: 6 }} alignItems="center">
          <Grid item xs={12} sm={6} md={6}>
            <div className={styles.heading_wrapper}>
              <h2 className={styles.heading}>
                Welcome to UniSearch’s Complete{" "}
                <span className={"color-orange"}>IELTS Training</span> Course
              </h2>
              <p className={styles.sub_text}>
                Standardised practice kits and guidebooks can do only so much
                when it comes to IELTS prep. After all, English language
                proficiency requirements are a crucial component of your study
                abroad application. You want to be sure of your success when you
                step into that exam room, confident of your performance even
                before you receive your scores.
              </p>
              <p className={styles.sub_text}>
                Our Complete IELTS Training course is built with all this in
                mind. Our experienced coaches offer individualised performance
                evaluation and guidance geared toward each student. We combine
                classroom sessions and one-to-one consulting with simulated exam
                practice and practical resources to get your scores where they
                need to be!
              </p>

              <div className={styles.btn_wrapper}>
                <Link legacyBehavior href="/elearning/ielts">
                  <a className={`btn btn-secondary btn-bg`}>Learn More</a>
                </Link>
              </div>
            </div>
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <div className={styles.hero_image_wrapper}>
              <Image
                layout="responsive"
                width={561}
                height={647}
                blurDataURL={getAssets(
                  "assets/images/study/country_placeholder.webp"
                )}
                placeholder="blur"
                src={getAssets(
                  "/assets/images/elearning/intro-video-image.webp"
                )}
                alt="Intro video feature"
              />
              {/* <PlayButtonWithRipple colorOrange onClick={() => setOpen(true)} /> */}
            </div>
            {/* <ModalVideo
              channel="custom"
              autoplay
              isOpen={isOpen}
              url="https://d2ogu7kfbtzzv3.cloudfront.net/files/UniSearch_Finale-1634995602483.mp4"
              onClose={() => setOpen(false)}
            /> */}
          </Grid>
        </Grid>
      </div>
    </section>
  );
};

export default ElearningHomeIntro;
